import { Navigate, useLocation } from "react-router-dom";
import { isWallDisplayOnly } from "../../auth/roles";
import { useShownRoles } from "../../auth/useShownRoles";
import { PageSkeleton } from "../Skeleton";
import { useStartPage } from "./useHome";

/**
 * Release 1.5.0 (O-R64): "/" — after sign-in, on the logo and on the phone's Home tab — opens the person's start page,
 * decided by the server (their own choice while they may open it, otherwise Home with their role's view). The kiosk opens
 * the wall board. If the server cannot answer, the 1.4.0 landing page (`fallback`) is used.
 */
export function StartLanding({ fallback }: { fallback: string | null }) {
  const roles = useShownRoles();
  const location = useLocation();
  const kiosk = isWallDisplayOnly(roles);
  const start = useStartPage(!kiosk && fallback !== null);
  if (kiosk) return <Navigate to="/display" replace />;
  if (fallback === null) return <Navigate to="/request-access" replace />;
  if (start.isPending) return <PageSkeleton />;
  const to = start.data?.path ?? fallback;
  // Keep a hash (deep links into a page section) but never a query: the start page carries its own filters.
  return <Navigate to={`${to}${location.hash}`} replace />;
}
